import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import CookieBanner from "@/components/common/CookieBanner";

export default function PublicLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-white" data-testid="public-layout">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
